import styles from "./SizeHeader.module.scss";

type SizeHeaderProps = {
  sizeValue: string;
};

export function SizeHeader({ sizeValue }: SizeHeaderProps) {
  return (
    <div>
      <h2 id="select-size">
        <span
          aria-hidden="true"
          data-cy="size-heading"
          className={styles.size_text}
        >
          <strong
            data-cy="size-heading-text"
            className={styles["size_heading_text"]}
          >
            Size:&nbsp;
          </strong>
          {sizeValue ? (
            <p className={styles["size_value_text"]}>{sizeValue}</p>
          ) : (
            ""
          )}
        </span>
      </h2>
    </div>
  );
}
